export const documentTypes = [
  { id: '10', name: 'CC' },
  { id: '20', name: 'CE' },
  { id: '9', name: 'NIT' },
  { id: '30', name: 'PASAPORTE' },
]

export const documentGuestTypes = [
  { id: '50', name: 'TI' },
  { id: '10', name: 'CC' },
  { id: '20', name: 'CE' },
  { id: '9', name: 'NIT' },
  { id: '30', name: 'PASAPORTE' },
]

export const documentYoungTypes = [
  { id: '60', name: 'REGISTRO CIVIL' },
  { id: '50', name: 'TI' },
  { id: '30', name: 'PASAPORTE' },
]

export const accountTypes = [
  { id: '1', name: 'Ahorros' },
  { id: '2', name: 'Corriente' }
]

export const eventsGeneres = [
  { id: '1', name: 'Masculino' },
  { id: '2', name: 'Femenino' }
]

export const months = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];
